import React from 'react';
import { When } from '@/components';

import cx from './index.module.scss';

interface Props {
  title: string;
  subTitle?: string;
}

export const ShowTitle: React.FC<Props> = ({ title, subTitle }) => {
  return (
    <div className={cx('ShowTitle')}>
      <div className={cx('main-title')}>{title}</div>
      <When condition={!!subTitle}>
        <div className={cx('sub-title')}>{subTitle}</div>
      </When>
    </div>
  );
};
